// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeStripsResultsGetBody = {
  poolId: string;
  eventId?: string | null;
  userIds?: string[];
  stripNumber?: number | null;
};

export type typeStripsResultsGetOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | {
    winners: {
      stripWinnerId: string;
      eventId: string;
      gameLabel: string;
      stripNumber: number;
      stripLabel: string;
      row: number;
      rowLabel: string;
      digit: number;
      userId?: string | null;
      displayName: string;
      initials: string;
      wonAt: string;
      note: string;
    }[];
    filters: {
      members: { userId: string; displayName: string }[];
      games: { eventId: string; label: string }[];
      strips: { stripNumber: number; label: string }[];
    };
    viewer: { canManage: boolean };
  };
};

export type typeStripsResultsGetOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeStripsResultsGetOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeStripsResultsGetOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaStripsResultsGetBody = {
  type: "object",
  properties: {
    poolId: { type: "string", maxLength: 3000, minLength: 1 },
    eventId: {
      oneOf: [
        { type: "string", maxLength: 3000, minLength: 1 },
        { enum: [null] },
      ],
    },
    userIds: {
      type: "array",
      items: { type: "string", maxLength: 3000, minLength: 1 },
    },
    stripNumber: { oneOf: [{ type: "integer" }, { enum: [null] }] },
  },
  required: ["poolId"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createStripsResultsGet(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaStripsResultsGetBody);
  }

  return async function postStripsResultsGet(
    payload: typeStripsResultsGetBody,
  ): Promise<typeStripsResultsGetOutput200 | typeStripsResultsGetOutput400> {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postStripsResultsGet" failed before calling the network. #8e7c86d36203`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#8e7c86d36203" },
        },
        data: null,
      } as typeStripsResultsGetOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/strips/results-get`,
      httpMethod: "POST",
      options,
    })) as typeStripsResultsGetOutput200 | typeStripsResultsGetOutput400;
  };
}
